module.exports = __webpack_public_path__ + "img/icon_impedimento_visual.4ea43705.svg";